<template>
  <main class="w-100">
     <LoadingSpinner v-if="loading" />
     <div v-else>
        <template v-if="workspace_domain.length > 0">
          <DeleteDomains
            @refresh="getDomainFree()"
            :workspace_domain="workspace_domain"
            :complete="true"
            :key="keydomains">
          </DeleteDomains>
        </template>
    </div>
  </main>
</template>

<script>

import LoadingSpinner from "@/components/LoadingSpinner.vue";
import DeleteDomains from "@/components/Workspace/DeleteDomains.vue";
import {
  adminService,
  monitorService,
  campaignsService,
  workspaceService,
  usersService,
  opportunitiesService
} from "@/_services";

export default {
  name: 'DeleteDomainList',
  components: {
    LoadingSpinner, DeleteDomains
  },
  props: {
    condition: {
      type: String,
      default: 'all'
    }
  },
  computed: {
    capitalizeFirstLetter() {
     return (word) => {
      return word.charAt(0).toUpperCase() + word.slice(1);
     }
    }
  },
  data() {
    return {
      keydomains:23,
      loading: true,
      list: [],
      workspace_domain: [],
      // workspace_domain_aux: [],
      // workspace_domain_id: false,
      // selectcheckbox:false,
    };
  },

  created(){
    this.getDomainFree();
    //this.getAccountEmails()
  },
  methods: {
    getDomainFree(){
      this.loading = true;
      workspaceService.getFreeDomainsByClient(false, true).then((result) => {
        this.workspace_domain = result
        this.loading = false;
        });
    },
  },
};
</script>
